export const environment = {
  production: false,
  environmentCd: 'dev',
  appCd: 'welcome',
  login: {
    isbeLogin: 'https://biz-marche-login.nakamenosakura.com/index.html',
    // isbeLogin: 'http://localhost:5173/index.html',　//デバッグ用
    isbeAppCd: '',
    copyright: '',
  },
}
